export const faqs_data = [
  {
    question: '¿Qué habilidades promovemos con nuestros cursos de vacaciones?',
    answer: (
      <>
        En Crack The Code promovemos la programación, el diseño gráfico digital, la
        generación de contenido y el desarrollo de videojuegos, entre otras habilidades
        tech.
      </>
    )
  },
  {
    question:
      '¿Por qué aprovechar las vacaciones de tu hij@ para llevar cursos de tecnología?',
    answer: (
      <>
        Porque podrás añadir un plus muy importante a su tiempo de descanso y
        entretenimiento: que aprendan cosas nuevas mientras se divierten, las cuales
        pueden darles oportunidades profesionales en un futuro.
      </>
    )
  },
  {
    question: '¿Por qué elegirnos como academia de programación para tus hij@s?',
    answer: (
      <>
        En Crack The Code contamos con la experiencia de haber formado en tecnología a más
        de 8.500 niños y adolescentes de distintas partes de Latinoamérica. Nuestra
        academia de programación difunde, de manera divertida y didáctica, los
        aprendizajes con los que los pequeños pueden empezar a crear cosas increíbles
        mediante la tecnología.
      </>
    )
  },
  {
    question: '¿Qué metodología de aprendizaje aplicamos en nuestra academia online?',
    answer: (
      <>
        En Crack The Code aplicamos la metodología Thinking Based Learning, con la que
        buscamos que nuestros estudiantes sean protagonistas de su propio aprendizaje y
        encuentren soluciones a retos usando su capacidad crítica y creativa. Módulo a
        módulo, ayudamos a niñas y niños a potenciar sus habilidades tecnológicas.
      </>
    )
  }
];
